/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */

import React, { useState } from 'react';
import { Image, View, StyleSheet } from 'react-native';

import { isWeb, isNative } from '@global/screens';
import { imageSource } from '@global/helpers';
import Colors from '@global/colors';
import PropTypes from 'prop-types';

const propTypes = {
  source: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
  ]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  compressWidth: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
  ]),
  svg: PropTypes.bool,
  isPhoto: PropTypes.bool,
  isResolveAsset: PropTypes.bool,
  showDefault: PropTypes.bool,
  disableCDN: PropTypes.bool,
  isManualReload: PropTypes.bool,
  resizeMode: PropTypes.oneOf([
    'cover',
    'contain',
    'stretch',
    'repeat',
    'center',
  ]),
  testID: PropTypes.string,
};

const defaultProps = {
  source: '',
  width: 10,
  height: 10,
  compressWidth: isWeb ? 450 : 300,
  style: {},
  svg: false,
  isPhoto: false,
  isResolveAsset: false,
  showDefault: false,
  disableCDN: false,
  isManualReload: false,
  resizeMode: 'cover',
  testID: 'image-default',
};

const imageDefault = require('@/assets/img/default/image-default.png');
const userDefault = require('@/assets/img/default/user-default.png');

const RenderImage = React.memo(
  ({
    source,
    disableCDN,
    defaultImage,
    svg,
    style,
    width,
    height,
    isManualReload,
    resizeMode,
    testID,
  }) => {
    const [isLoading, setIsLoading] = useState(true);

    return source ? (
      isManualReload ? (
        <View
          style={[
            {
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            },
            { width, height },
          ]}>
          {isLoading && (
            <Image
              testID={`${testID}-image-default`}
              source={defaultImage}
              style={[
                {
                  width: '100%',
                  height: '100%',
                },
                style,
                { width, height, position: 'absolute' },
              ]}
              resizeMode="cover"
            />
          )}
          <Image
            testID={testID}
            source={source}
            style={[styles.image, style, { width, height }]}
            resizeMode={resizeMode}
            onLoadStart={() => setIsLoading(true)}
            onLoadEnd={() => setIsLoading(false)}
            onError={() => setIsLoading(true)}
            disableCDN={disableCDN}
          />
        </View>
      ) : (
        <Image
          testID={testID}
          width={width || 10}
          height={height || 10}
          style={style}
          source={source}
          defaultSource={defaultImage}
          disableCDN={disableCDN}
          resizeMode={resizeMode}
        />
      )
    ) : (
      <View
        style={[
          styles.placeholder,
          {
            width: width || 10,
            height: height || 10,
          },
        ]}></View>
    );
  },
  (prev, next) => prev == next,
);

const ImageDefault = (props) => {
  const {
    source,
    width,
    compressWidth,
    height,
    style,
    svg,
    isPhoto,
    isResolveAsset,
    showDefault,
    disableCDN,
    isManualReload,
    resizeMode,
    testID,
  } = props;

  let defaultImg = isPhoto ? userDefault : imageDefault;
  if (isNative && svg) {
    const resolvedAsset = Image.resolveAssetSource(defaultImg);
    if (resolvedAsset && resolvedAsset.uri) {
      defaultImg = { uri: resolvedAsset.uri };
    }
  }

  let finalSource = '';
  if (source) {
    finalSource =
      typeof source !== 'object' && !svg
        ? `${source}?${Math.random()}`
        : source;

    if (
      !svg &&
      typeof finalSource !== 'object' &&
      finalSource.toString().indexOf('http') > -1
    ) {
      finalSource = {
        uri: showDefault
          ? finalSource
          : disableCDN
          ? finalSource
          : imageSource(finalSource, compressWidth),
      };
    }

    if (isNative && isResolveAsset) {
      const resolvedAsset = Image.resolveAssetSource(source);
      if (resolvedAsset && resolvedAsset.uri) {
        finalSource = { uri: resolvedAsset.uri };
      }
    }
  } else {
    finalSource = defaultImg;
  }
  if (isNative && typeof source == 'number' && !svg && !isResolveAsset) {
    finalSource = defaultImg;
  }

  return (
    <RenderImage
      testID={testID}
      source={finalSource}
      width={width}
      height={height}
      style={style}
      defaultImage={defaultImg}
      svg={svg}
      isManualReload={isManualReload}
      resizeMode={resizeMode}
    />
  );
};

const styles = StyleSheet.create({
  placeholder: {
    backgroundColor: Colors.grey0,
    justifyContent: 'center',
    overflow: 'hidden',
  },
});

ImageDefault.propTypes = propTypes;
ImageDefault.defaultProps = defaultProps;

export default React.memo(ImageDefault, (prev, next) => prev == next);
